export default __webpack_public_path__ + "static/media/secure.0685d8b2.svg";